import { useRef } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

import styles from '../styles.module.scss';

const AnimateEnter = ({ children }: { children: React.ReactElement }) => {
  const skipAnimation = useRef<boolean>(false);
  if (
    skipAnimation.current ||
    (document.documentElement || document.documentElement).scrollTop >
      window.innerHeight
  ) {
    skipAnimation.current = true;
    return children;
  }

  return (
    <ScrollAnimation
      animateOnce
      animateIn={styles.enter}
      initiallyVisible={false}
    >
      {children}
    </ScrollAnimation>
  );
};

export default AnimateEnter;
